import { useAsync } from '@exodus/react-hooks';
import { useExodus, useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
import { isCombinedAsset } from '../types.js';
const useAssetReady = (params) => {
    const { assetName, walletAccount } = params;
    const exodus = useExodus();
    const selectors = useSelectors();
    const walletAccountInstance = useSelector(selectors.walletAccounts.getMemoized(walletAccount));
    const isHardware = walletAccountInstance.isHardware;
    const allAssets = useSelector(selectors.assets.all);
    const asset = allAssets[assetName];
    const restoringAssets = useSelector(selectors.restoringAssets.data);
    const isAssetRestoring = isCombinedAsset(asset)
        ? asset.combinedAssets.some(({ baseAsset }) => Boolean(restoringAssets[baseAsset.name]))
        : asset
            ? Boolean(restoringAssets[asset.baseAsset.name])
            : false;
    const { value: assetReady, loading } = useAsync(async () => {
        if (!assetName)
            return false;
        if (!isHardware)
            return true;
        try {
            await exodus.addressProvider.getReceiveAddress({
                assetName,
                walletAccount,
            });
            return true;
        }
        catch {
            return false;
        }
    }, [assetName, walletAccount, isAssetRestoring]);
    return { assetReady, loading };
};
export default useAssetReady;
